import apiClient from 'hub-http/clients/apiClient';
// @ts-expect-error no types
import { catchAndRethrowNetworkError } from 'crm_data/bCommerce/monitoring/errorUtils';
export const createOnboardingLink = ({
  type
}) => apiClient.post(`payments/v1/hosted-onboarding-links?type=${type}`).catch(catchAndRethrowNetworkError);